import "babel-polyfill";
import Vue from "vue";
import App from "./App.vue";
// import router from "./router";
// import store from "./store";
// import "./registerServiceWorker";
// import { createProvider } from "./vue-apollo";
// import "./plugins/element";
// import "./plugins/iview";
import axios from 'axios'
import './modules/activity/plugins/rest.scss'
// 弹窗
import Dialog from './modules/activity/common/dialog'

Vue.use(Dialog)
// 兼容IE9页面滚动属性
window.requestAnimationFrame = window.requestAnimationFrame||function (fn) {return setTimeout(fn,1000/60)}
window.cancelAnimationFrame = window.cancelAnimationFrame ||clearTimeout;

var VueScrollTo = require('vue-scrollto');
Vue.use(VueScrollTo)

// 
declare var FB: any;
declare var window: any;
declare var CONFIG: Object;
window.fbAsyncInit = function () {
  FB.init({
    appId: CONFIG['data'].fbId,
    autoLogAppEvents: true,
    xfbml: true,
    version: 'v3.0'
  });
};

(function (d, s, id) {
  var js, fjs: any = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) {
    return;
  }
  js = d.createElement(s);
  js.id = id;
  js.src = "https://connect.facebook.net/en_US/sdk.js";
  fjs.parentNode.insertBefore(js, fjs);
}(document, 'script', 'facebook-jssdk'));

Vue.prototype.$http = axios.create({
  baseURL: ' http://172.16.10.124:8191',
})

new Vue({
  // router,
  // store,
  // apolloProvider: createProvider(),
  render: h => h(App),
}).$mount("#app");
